import script from "./TestimonialCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&setup=true&lang=js"

import "./TestimonialCard.vue?vue&type=style&index=0&id=20df07d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20df07d5"]])

export default __exports__